import api from "./api";

import { QuestionType } from "../types/QuestionsTypes";

export const create_question = async (data: any) => {
	try {
		const response = await api.post("data/questions", data);

		console.log(response);

		return response;
	} catch (error) {
		return error;
	}
};

export const list_questions = async (checklist: number) => {
	try {
		const response = await api.get(`data/questions&checklist=${checklist}`);

		if (response.data) return response.data;
	} catch (error) {
		return error;
	}
};

export const remove_question = async (questions: number[]) => {
	try {
		const response = await api.delete("data/questions", {
			data: { questions },
		});

		return response;
	} catch (error) {
		return error;
	}
};

export const edit_questions = async (questions: QuestionType[]) => {
	console.log("questions que estao sendo enviadas para update", questions);
	try {
		const response = await api.put("data/questions", questions);

		if (response.data) return response.data;
	} catch (error) {
		return error;
	}
};
